'use strict';

/**
 * keycloak-js v26 uses Promise.withResolvers in updateToken().
 * babel-polyfill replaces Promise without that method — patch after polyfill loads.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers
 */
function withResolversImpl() {
  let resolve;
  let reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return { promise, resolve, reject };
}

function patchOne(PromiseCtor) {
  if (!PromiseCtor || typeof PromiseCtor.withResolvers === 'function') {
    return;
  }

  try {
    Object.defineProperty(PromiseCtor, 'withResolvers', {
      configurable: true,
      writable: true,
      enumerable: false,
      value: withResolversImpl,
    });
  } catch (e) {
    try {
      // eslint-disable-next-line no-extend-native
      PromiseCtor.withResolvers = withResolversImpl;
    } catch (e2) {
      /* ignore */
    }
  }
}

export function ensurePromiseWithResolvers() {
  if (typeof globalThis !== 'undefined' && globalThis.Promise) {
    patchOne(globalThis.Promise);
  }
  if (typeof Promise !== 'undefined') {
    patchOne(Promise);
  }
}

ensurePromiseWithResolvers();

if (typeof queueMicrotask === 'function') {
  queueMicrotask(ensurePromiseWithResolvers);
} else if (typeof Promise !== 'undefined' && typeof Promise.resolve === 'function') {
  Promise.resolve().then(ensurePromiseWithResolvers);
}
setTimeout(ensurePromiseWithResolvers, 0);
